import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// FR namespaces
import frCommon from "./locales/fr/common.json";
import frAuth from "./locales/fr/auth.json";
import frAnnonces from "./locales/fr/annonces.json";
import frArtisan from "./locales/fr/artisan.json";
import frClient from "./locales/fr/client.json";
import frErrors from "./locales/fr/errors.json";
import frDevis from "./locales/fr/devis.json";
import frAide from "./locales/fr/aide.json";
import frLegal from "./locales/fr/legal.json";

// AR namespaces
import arCommon from "./locales/ar/common.json";
import arAuth from "./locales/ar/auth.json";
import arAnnonces from "./locales/ar/annonces.json";
import arArtisan from "./locales/ar/artisan.json";
import arClient from "./locales/ar/client.json";
import arErrors from "./locales/ar/errors.json";
import arDevis from "./locales/ar/devis.json";
import arAide from "./locales/ar/aide.json";
import arLegal from "./locales/ar/legal.json";

export type Locale = "fr" | "ar";
export const LOCALES: Locale[] = ["fr", "ar"];
export const DEFAULT_LOCALE: Locale = "fr";

/**
 * Détecte la langue depuis le path URL (/fr/... ou /ar/...).
 * Fallback sur localStorage, puis "fr".
 */
function detectLocaleFromPath(): Locale {
  const segments = window.location.pathname.split("/").filter(Boolean);
  const first = segments[0];
  if (first === "ar") return "ar";
  if (first === "fr") return "fr";

  const stored = localStorage.getItem("hirafi_lang");
  if (stored === "ar" || stored === "fr") return stored;

  return DEFAULT_LOCALE;
}

i18n.use(initReactI18next).init({
  lng: detectLocaleFromPath(),
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: "common",
  ns: ["common", "auth", "annonces", "artisan", "client", "errors", "devis", "aide", "legal"],
  resources: {
    fr: {
      common: frCommon,
      auth: frAuth,
      annonces: frAnnonces,
      artisan: frArtisan,
      client: frClient,
      errors: frErrors,
      devis: frDevis,
      aide: frAide,
      legal: frLegal,
    },
    ar: {
      common: arCommon,
      auth: arAuth,
      annonces: arAnnonces,
      artisan: arArtisan,
      client: arClient,
      errors: arErrors,
      devis: arDevis,
      aide: arAide,
      legal: arLegal,
    },
  },
  interpolation: {
    escapeValue: false, // React gère déjà l'échappement XSS
  },
});

export default i18n;
